/**
 * FIN-11304 / FIN-12628 — the side panel's typed detail section.
 *
 * The design gives every event the same header block (Event Type / Timestamp /
 * Fraud Score / Details) and then ONE section whose title comes from
 * `detail.eventType` and whose rows are the fields an admin ticked for On Click.
 *
 * THIS FILE USED TO BE THE SPEC. It held a per-eventType table of the design's
 * rows (LOGIN, OTP, PASSWORD_RESET, BANK_TRANSFER), accessors reading
 * `detail.amount` / `detail.ipAddress` / `detail.device`, a `customData` JSON
 * parser, and a note about which columns the BE had yet to map. All of it is
 * gone: `EventDetail` no longer carries any of those keys, and the rows are no
 * longer ours to choose — the admin picks them in Settings -> Event Fields and
 * the BE resolves them into `detail.fields[]`.
 *
 * Two consequences worth knowing:
 *   - the old table was keyed on eventType values (`OTP`, `BANK_TRANSFER`) that
 *     never matched the wire (`LOGIN_MFA_WITH_OTP`, `XBORDER`), so those sections
 *     had in practice never rendered
 *   - the design's "OTP Channel: SMS" / "Attempts: 5" came from `customData`,
 *     which the contract dropped entirely. They can only return as registered
 *     custom fields configured through the settings screen — raised with BE.
 *
 * The node's cap is 3 configured fields and the panel's is 15 — the same caps
 * the settings screen and the backend enforce (fields.js MAX_*_USER_FIELDS).
 */
import { panelFields, toRow } from './fields';

const d = (event) => event.detail || {};

/**
 * `ACTIVITY DETAILS · PASSWORD_RESET` — the generic kind, then the specific type.
 * Falls back to the kind alone when the BE sends no eventType, rather than
 * printing a trailing separator with nothing after it.
 */
export const toSectionTitle = (event) => {
  const kind = (event.type || '').toUpperCase();
  const specific = d(event).eventType;
  if (!kind) return undefined;
  return specific ? `${kind} DETAILS · ${specific}` : `${kind} DETAILS`;
};

/**
 * The typed rows for one event — the admin's On Click selection, capped at 15.
 *
 * The identifier and the timestamp are NOT here: both are pinned in the panel
 * header (Event ID / Timestamp, see toEvents' toDetailRows), so they are never
 * one of the admin's 15 and never appear twice.
 *
 * `toRow` RATHER THAN A SECOND COPY OF THE MAPPING. This once built its own
 * `{ label, value: String(field.value) }`, and every rule added to `toRow`
 * silently skipped the one surface most people look at — the empty-value
 * placeholder from FIN-13590 shipped that way, so the panel showed `null` while
 * the node beside it showed `—`.
 */
export const toSectionRows = (event) => panelFields(event).map(toRow);
